export default __webpack_public_path__ + "static/media/wedding.33a98574.svg";